function init() {

	var mainNav = document.getElementById("main-nav"),
		secondaryMenuToggler = document.getElementById("secondary-nav-toggler"),
		htmlTag = document.getElementsByTagName("html")[0],
		mainHeader = document.getElementById("main-header"),
		menuAnimationDuration = 50,
		openingMenuDuration = 300,
		cssMenuItemsTransitionDuration = 300;

	if(secondaryMenuToggler){
		secondaryMenuToggler.addEventListener("click", () => {

			let isOpen = mainNav.classList.contains("open");
			if (isOpen) {
				secondaryMenuToggler.setAttribute("aria-expanded", "false");
				mainNav.classList.remove("open");
				htmlTag.classList.remove("no-scroll");
			} else {
				secondaryMenuToggler.setAttribute("aria-expanded", "true");
				mainNav.classList.add("open");
				htmlTag.classList.add("no-scroll");
			}
		});
	}

	let isOpen = false; // il menu inizialmente è chiuso

	// Aggiunge la classe "is-visible" a ogni voce del menu
	// in ordine dall'ultima alla prima con delay incrementale di 200ms
	const animateMenuItems = () => {
		// Seleziona solo le voci di primo livello usando il selettore :scope > .menu-item
		let menuItems = mainNav.querySelectorAll('.menu-item, .istitutional, .socials');
		
		setTimeout(() => {
			Array.from(menuItems)
			.forEach((item, index) => {
				setTimeout(() => {
					item.classList.add("is-visible");
				}, index * menuAnimationDuration );
			});
		}
		, openingMenuDuration + 200);
		
	};


	// Rimuove la classe "is-visible" da ogni voce del menu
	const clearMenuItems = () => {
		// Seleziona gli stessi elementi animati in animateMenuItems
		let menuItems = mainNav.querySelectorAll('.menu-item, .istitutional, .socials');
		menuItems.forEach((item, index) => {
			setTimeout(() => {
				item.classList.remove("is-visible");
			}, index * menuAnimationDuration );
		});
		// La durata totale dell'animazione è pari a (numero di item * menuAnimationDuration ms)
		return menuItems.length * menuAnimationDuration ;
	};



	const closeMenu = () => {
		const clearDuration = clearMenuItems();
		setTimeout(() => {
			secondaryMenuToggler.setAttribute("aria-expanded", "false");
			mainNav.classList.remove("open");
			htmlTag.classList.remove("no-scroll");
			isOpen = false;
		}, clearDuration + cssMenuItemsTransitionDuration);
		
		
		
	}

	const toggleMenuState = () => {
		// isOpen = mainNav.classList.contains("open");
		if (isOpen) {
			closeMenu();
		} else {
			isOpen = true;
			secondaryMenuToggler.setAttribute("aria-expanded", "true");
			mainNav.classList.add("open");
			htmlTag.classList.add("no-scroll");
			animateMenuItems();
		}
	}

	if (secondaryMenuToggler) {
		secondaryMenuToggler.addEventListener("click", () => toggleMenuState());
	}

}


export default { init };
